import { isValidPhoneNumber } from 'libphonenumber-js/core';
import metadata from 'libphonenumber-js/metadata.min.json';
import { boolean, mixed, object, string } from 'yup';

import {
  Gender,
  Language,
  MfaAuthenticationType,
} from '../../../../data/types/api/graphql';
import { isValidBirthDate } from '../../../../data/utils/date.utils';
import { messages, regExEmail, trim } from '../../../../data/utils/form.utils';

export const schema = object()
  .shape({
    app: boolean().default(true).nullable(),
    firstName: string()
      .transform(trim)
      .required(messages.required.id)
      .default('')
      .nullable(),
    lastName: string()
      .transform(trim)
      .required(messages.required.id)
      .default('')
      .nullable(),
    email: string()
      .transform(trim)
      .when('app', {
        is: true,
        then: fieldSchema =>
          fieldSchema
            .email(messages.invalidEmail.id)
            .matches(regExEmail, messages.invalidRegEx.id)
            .required(messages.required.id),
        otherwise: fieldSchema => fieldSchema.optional(),
      })
      .default('')
      .nullable(),
    gender: mixed<Gender>()
      .oneOf(Object.values(Gender))
      .required(messages.required.id),
    birthDate: string()
      .transform(trim)
      .test('max-date', messages.invalidDate.id, value =>
        isValidBirthDate(value ?? '')
      )
      .required(messages.required.id)
      .default('')
      .nullable(),
    language: mixed<Language>()
      .oneOf(Object.values(Language))
      .required(messages.required.id)
      .default(Language.Nl),
    mfaAuthenticationType: mixed<MfaAuthenticationType>()
      .oneOf(Object.values(MfaAuthenticationType))
      .required(messages.required.id)
      .default(MfaAuthenticationType.Sms),
    phoneNumber: string()
      .transform(trim)
      .when('app', {
        is: true,
        then: fieldSchema =>
          fieldSchema
            .test('international-phone', messages.invalidPhone.id, value =>
              value ? isValidPhoneNumber(value, metadata) === true : false
            )
            .required(messages.required.id),
        otherwise: fieldSchema => fieldSchema.optional(),
      })
      .default('')
      .nullable(),
    postalCode: string()
      .max(7, messages.maxLength.id)
      .uppercase()
      .transform(trim)
      .matches(/^\d{4}/, messages.invalidRegEx.id)
      .required(messages.required.id)
      .default('')
      .nullable(),
    dutchInsurance: boolean().default(true).nullable(),
    noShowProtocol: boolean().default(false).nullable(),
  })
  .required()
  .noUnknown();
